export default "__VITE_ASSET__Cpj3cHI2__"